import { twMerge } from 'tailwind-merge';

import { Text } from '@/_components';

export function NoDataMessage({ message, className }: { message: string; className?: string }) {
  return (
    <article className={twMerge('self-center pb-6 text-center', className)}>
      <Text className="text-c-card-muted text-base font-medium" as="small">
        {message}
      </Text>
    </article>
  );
}
